import { type FC, useRef, useState } from "react"

import { type Plan } from "."

type Props = { currentPlan: Plan; onPlanChange(plan: Plan): void }
const PlanSelector: FC<Props> = ({ currentPlan, onPlanChange }) => {
	const [isHovering, setHovering] = useState(false)

	const timeoutRef = useRef<NodeJS.Timeout>(null)

	const plans = [
		{ key: "free", label: "Free", onClick: () => onPlanChange("free") },
		{ key: "appsumo", label: "AppSumo", onClick: () => onPlanChange("appsumo") },
		{ key: "productcanyon", label: "Product Canyon", onClick: () => onPlanChange("productcanyon") },
		{ key: "basic", label: "Basic", onClick: () => onPlanChange("basic") },
		{ key: "start", label: "Start", onClick: () => onPlanChange("start") },
		{ key: "scale", label: "Scale", onClick: () => onPlanChange("scale") },
	]

	const currentPlanData = plans.find(plan => plan.key === currentPlan) || plans[0]

	const handleMouseEnter = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
			timeoutRef.current = null
		}
		setHovering(true)
	}

	const handleMouseLeave = () => {
		timeoutRef.current = setTimeout(() => setHovering(false), 150)
	}

	return (
		<div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<button
				type="button"
				onClick={currentPlanData.onClick}
				className="cursor-pointer rounded px-2.5 py-1.5 text-white/60 transition-colors hover:bg-white/10 hover:text-white"
			>
				plan: <span className="text-lime-400">{currentPlanData.label.toLowerCase()}</span>
			</button>

			{isHovering && (
				<div
					className="absolute bottom-full left-0 mb-1 flex w-max min-w-full flex-col overflow-hidden rounded-lg border border-white/10 bg-black shadow-2xl"
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					{plans
						.filter(plan => plan.key !== currentPlan)
						.map(({ key, label, onClick }) => (
							<button
								key={key}
								type="button"
								onClick={onClick}
								className="cursor-pointer px-3 py-1.5 text-left text-white/50 transition-colors hover:bg-white/10 hover:text-white"
							>
								{label.toLowerCase()}
							</button>
						))}
				</div>
			)}
		</div>
	)
}

export default PlanSelector
